import { render, staticRenderFns } from "./TestPathways.vue?vue&type=template&id=5d5dc48a&"
import script from "./TestPathways.vue?vue&type=script&lang=js&"
export * from "./TestPathways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports